<template>
  <div class="videoalpha">
    <img
      v-if="condition"
      :src="`/textures/${$route.params.city}.png`"
      alt="hero video"
    >
    <video
      v-else
      class="videoalpha__item"
      playsinline
      autoplay
      muted
      loop
    >
      <source :src="`/textures/${$route.params.city}.webm`" type='video/webm;' />
    </video>
  </div>
</template>

<script>
import { isIOS } from '@/scripts/utils';

export default {
  name: 'videoAlpha',
  data() {
    return {
      isIOS,
    };
  },
  computed: {
    condition() {
      return isIOS() || window.safari;
    },
  },
};
</script>

<style lang="scss" scoped>
.videoalpha {
  position: absolute;
  width: 60vw;
  top: 0;
  right: -4 * $unit-vw;

  @include mq($until: ipadP) {
    position: relative;
    width: 100%;
    top: 0;
    right: auto;
    left: 0px;
  }

  video {
    width: 100%;
  }

  img {
    width: 100%;
  }
}
</style>
